import {useMediaQuery, useTheme} from "@material-ui/core"

export const useIsPhone = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down("md"))
}
